import { BREAKPOINT_MOBILE_IN_PX } from '../../client/constants';
import { closePanelByType } from './sidebar';
import { panelGroup, panelType } from '../constants';
import getPdfViewerApplication from '../../client/utils/pdfjs/pdfViewerApplication';

export default function navigateToSection(dest) {
  return (dispatch, getState) => {
    const state = getState();

    const shouldCloseSidePanel = state.clientSize.width < BREAKPOINT_MOBILE_IN_PX;
    if (shouldCloseSidePanel) {
      dispatch(closePanelByType(panelGroup.enhancements, panelType.outline));
    }
    getPdfViewerApplication().goToDestination(dest);
  };
}
